<template>
  <div class="tabs-common tabs-financial">
    <div class="block_1">
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Designated Bank</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.design_bank" placeholder="Designated Bank">
          <label>Designated Bank</label>
        </div>
      </div>
      <p class="common-title">Financial Details</p>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Source of Funds</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.source_funds" placeholder="Source of Funds">
          <label>Source of Funds</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Currency Code</label> -->
        <div class="col-sm-10">
          <NewSelectWrapper type="currency" v-model="tab_data.curr_code" placeholder="Currency Code"/>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Exchange Rate</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.exch_rate" placeholder="Exchange Rate">
          <label>Exchange Rate</label>
        </div>
      </div>
      <!-- <div class="line"></div> -->
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Total FOB Value</label> -->
        <div class="col-sm-4">
          <input type="text" class="form-control"
                 v-model="tab_data.total_fob_value" placeholder="Total FOB Value" style="width: 100% !important;">
                 <label>Total FOB Value</label>
        </div>
        <!-- <label class="col-sm-3 col-form-label">Total Ancillary Charges</label> --> 
        <div class="col-sm-4">
          <input type="text" class="form-control" v-model="tab_data.total_freight_charges"  style="width: 100% !important;" placeholder="Total Freight Charges">
          <label>Total Freight Charges</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Total C&F Value</label> -->
        <div class="col-sm-4">
          <input type="text" class="form-control" v-model="tab_data.total_anc_charges"  style="width: 100% !important;" placeholder="Total Ancillary Charges">
          <label>Total Ancillary Charges</label>
        </div>
        
        <div class="col-sm-4">
          <input type="text" class="form-control" v-model="tab_data.insh_value"  style="width: 100% !important;" placeholder="Insurance Value">
          <label>Insurance Value</label>
        </div>
      </div>
      <div class="mb-3 row">
        <div class="col-sm-4">
          <input type="text" class="form-control" v-model="tab_data.total_cf_value"  style="width: 100% !important;" placeholder="Total C&F Charges">
          <label>Total C&F Charges</label>
        </div>
        <div class="col-sm-4">
          <input type="text" class="form-control" v-model="tab_data.total_foc"  style="width: 100% !important;" placeholder="Total FOC">
          <label>Total FOC</label>
        </div>
      </div>
      <!-- <div class="line"></div> -->
      <p class="common-title" style="margin-top: 20px">Financial Details</p>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Proforma Invoice Number</label> -->
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.proforma_number" placeholder="Proforma Invoice Number">
          <label>Proforma Invoice Number</label>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-3 col-form-label">Proforma Invoice Date</label> -->
        <div class="col-sm-10">
          <NewDatepickerWrapper
          v-model="tab_data.proforma_date"
          type="date"
          placeholder="Proforma Invoice Date">
        </NewDatepickerWrapper>
        </div>
      </div>
      <!-- <div class="mb-3 row">
        <label class="col-sm-3 col-form-label">Applicant's Email</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.app_email" placeholder="Applicant's Email">
        </div>
      </div> -->
      <p class="common-title">Payment</p>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Payment Mode</label> -->
        <div class="col-sm-10">
          
          <NewSelectWrapper type="payment_type" v-model="tab_data.payment_mode" placeholder="Payment Mode"/>
          <!-- <input type="text" class="form-control" value="81 Not valid for forex"> -->
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Payment Date</label> -->
        <div class="col-sm-10">
          <NewDatepickerWrapper
          v-model="tab_data.payment_date"
          type="date"
          placeholder="Payment Date">
        </NewDatepickerWrapper>
          <!-- <input type="text" class="form-control" value=""> -->
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Transfer Mode</label> -->
        <div class="col-sm-10">
          <!-- <input type="text" class="form-control" value="TT TELEGRAPHIC TRANSFER"> -->
          <NewSelectWrapper type="transporttype" v-model="tab_data.transfer_mode" placeholder="Transfer Mode"/>
        </div>
      </div>
      <div class="mb-3 row">
        <!-- <label class="col-sm-2 col-form-label">Terms of Delivery</label> -->
        <div class="col-sm-10">
          <NewSelectWrapper type="delivery_term" v-model="tab_data.terms_of_delivery" placeholder="Terms of Delivery"/>
          <!-- <input type="text" class="form-control" v-model="tab_data.terms_of_delivery" placeholder="Terms of Delivery"> -->
        </div>
      </div>
      <!-- <div class="mb-3 row">
        <label class="col-sm-2 col-form-label">Beneficiary Country</label>
        <div class="col-sm-10">
          <NewSelectWrapper type="country" v-model="tab_data.bnf_country" placeholder="Beneficiary Country"/>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-sm-2 col-form-label">Beneficiary Phone</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.bnf_phone" placeholder="Beneficiary Phone">
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-sm-2 col-form-label">Beneficiary Fax</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.bnf_fax" placeholder="Beneficiary Fax">
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-sm-2 col-form-label">Beneficiary Email</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="tab_data.bns_email" placeholder="Beneficiary Email">
        </div>
      </div> -->
    </div>
    <!-- <div class="foot_pagination">
      <img src="@/assets/chevron_left24.png" alt="" v-if="cur_tab_name!='Header'" @click="page_change('Transport',2)">
      {{ cur_tab_name }}
      <img src="@/assets/chevron_right24.png" alt="" v-if="cur_tab_name!='Support Information'"
           @click="page_change('Goods',4)">
    </div> -->
  </div>
</template>

<script>
import common from "@/mixins/common-form-m";
import NewSelectWrapper from './../../fields/NewSelectWrapper.vue'
import NewDatepickerWrapper from './../../fields/NewDatepickerWrapper.vue'
export default {
  name: 'tabs-financial',
  props: ['cur_tab_name', 'indata'],
  components: {
    NewSelectWrapper,NewDatepickerWrapper
  },
  data() {
    return {
      tab_data: {
        design_bank: 0,
        source_funds:'',
        curr_code:'',
        exch_rate:'',
        total_fob_value:'',
        total_foc: '',
        total_cf_value:'',
        total_anc_charges:'',
        total_freight_charges: '',
        insh_value: '',
        proforma_number:'',
        proforma_date:'',
        app_email:'',
        bnf_country:'',
        bnf_phone:'',
        bnf_fax:'',
        bns_email:'',
        payment_mode: '',
        payment_date: '',
        transfer_mode: '',
        terms_of_delivery: '',
      }
    }
  },
  mixins: [common],
  methods: {}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tabs-financial {
  background-color: transparent;
  padding: 0;

  // .block_1 {
  //   background-color: #fff;
  //   border-radius: 20px;
  //   padding: 24px;
  //   margin-bottom: 20px;
  // }

  // .block_2 {
  //   padding-bottom: 60px;
  // }

  .line {
    height: 1px;
    width: 60%;
    background-color: #488E53;
    margin: 10px 0;
  }
}
</style>
